var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-content" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "title" }, [_vm._v("联系我们")]),
        _c("div", { staticClass: "line" }),
        _c("div", { staticClass: "part-two" }, [
          _c("div", { staticClass: "left-wrapper" }, [
            _c("span", { staticClass: "detail" }, [
              _c("span", { staticClass: "bold" }, [_vm._v("公司：")]),
              _vm._v("北京海科融通支付服务有限公司 ")
            ]),
            _c("div", { staticClass: "detail" }, [
              _c("span", { staticClass: "bold" }, [_vm._v("电话：")]),
              _vm._v("010-82685056")
            ]),
            _c("div", { staticClass: "detail" }, [
              _c("span", { staticClass: "bold" }, [_vm._v("地址：")]),
              _vm._v("北京市海淀区西直门北大街甲43号金运大厦"),
              _c("br"),
              _vm._v("A座12层 ")
            ]),
            _c("div", { staticClass: "qrcode-wrap" }, [
              _c("span", { staticClass: "line" }),
              _c("div", { staticClass: "qr-wrap" }, [
                _c("span", { staticClass: "qr-code" }),
                _c("span", [_vm._v("海科云服务号")])
              ])
            ])
          ]),
          _c("div", { staticClass: "right-wrapper" }, [
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "logo" }),
              _c("div", { staticClass: "title" }, [
                _vm._v(" ⾸⻚ | 关于我们｜产品介绍｜企业动态｜联系我们 ")
              ]),
              _c("div", { staticClass: "Copyright" }, [
                _vm._v("Copyright © 2015-2022")
              ]),
              _c("div", { staticClass: "Copyright ICP" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://beian.miit.gov.cn/",
                      target: "_blank"
                    }
                  },
                  [_vm._v("皖ICP备2021013945号-1 ")]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }